export default __webpack_public_path__ + "static/media/imperative-recipe.bc6ab173.jpeg";